<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <apexchart type="bar" height="310" :options="chartOptions" :series="series" />
</div>  
</template>

<script>
import Papa from "papaparse";
export default {
  name: "Regions",
  data: () => ({
    breakdownRegions: [],
    series: [
      {
        name: "series1",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      //colors: ["#A91036", "#961E49", "#94204C", "#7F3062", "#6A4078", "#54508D", "#3F60A3", "#2A70B9", "#1580CF", "#0090E5"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: false,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 2
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          distributed: true
        }
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      yaxis: 
      {
        title: {
          text: "Confirmed"
        }
      }
    }
  }),
  created() {
    //get the province breakdown data
    var self = this
    var d = new Date()
    var url = "data/toupdate/breakdown_regions.csv"
    url += "?etag=" + d.toISOString()

    Papa.parse(url, {
      download: true,
      header: true,
      skipEmptyLines: true,
      complete: function(results) {
        self.breakdownRegions = results.data
      }
    })  
  },
  methods: {
    loadCases(data, provinceDisplay) {
      this.series[0].data = [];

      var provData = this.breakdownRegions.filter(d => d.district_munic !== "Unknown");

      //check if only one prov selected
      if(provinceDisplay && provinceDisplay !== "") {
        provData = this.breakdownRegions.filter(d => d.province === provinceDisplay && d.district_munic !== "Unknown");
      }

      //sort data grouped by districts
      var dists = [];

      for (var i = 0; i < provData.length; i++) {
        var match = dists.find(
          d => d.district_munic === provData[i].district_munic
        );
        if (match) {
          //update the record
          match.district_munic_confirmed += provData[i].confirmed * 1;
          match.district_munic_recovered += provData[i].recovered * 1;
          match.district_munic_deceased += provData[i].deceased * 1;
          match.local_munics.push(provData[i]);

        } else {
          //not found
          dists.push({
            district_munic: provData[i].district_munic,
            district_munic_confirmed: provData[i].confirmed * 1,
            district_munic_recovered: provData[i].recovered * 1,
            district_munic_deceased: provData[i].deceased * 1,
            local_munics: [provData[i]],
            province: provData[i].province
          });

        }
      }

      //sort by count desc
      dists = dists.sort(function(a, b) {
        a = a.district_munic_confirmed;
        b = b.district_munic_confirmed;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //get top regions only
      dists = dists.slice(0, 10);

      //loop and extract cols and vals
      var cols = [];
      var vals = [];
      var newColors = [];

      for (var i = 0; i < dists.length; i++) {
        if(provinceDisplay && provinceDisplay !== "") {
          cols.push(dists[i].district_munic);
        }
        else {
          cols.push([dists[i].district_munic,dists[i].province]);
        }
        
        vals.push(dists[i].district_munic_confirmed);

        //check the range for the heatmap color same as map
        if(dists[i].district_munic_confirmed >= 0 && dists[i].district_munic_confirmed <= 100) {
          newColors.push('#0090E5')
        }
        else if(dists[i].district_munic_confirmed >= 101 && dists[i].district_munic_confirmed <= 250) {
          newColors.push('#3F60A3')
        }
        else if(dists[i].district_munic_confirmed >= 251 && dists[i].district_munic_confirmed <= 500) {
          newColors.push('#54508D')
        }
        else if(dists[i].district_munic_confirmed >= 501 && dists[i].district_munic_confirmed <= 1000) {
          newColors.push('#6A4078')
        }
        else if(dists[i].district_munic_confirmed >= 1001 && dists[i].district_munic_confirmed <= 2500) {
          newColors.push('#7F3062')
        }
        else if(dists[i].district_munic_confirmed >= 2501 && dists[i].district_munic_confirmed <= 5000) {
          newColors.push('#94204C')
        }
        else if(dists[i].district_munic_confirmed >= 5001 && dists[i].district_munic_confirmed <= 10000) {
          newColors.push('#961E49')
        }
        else if(dists[i].district_munic_confirmed >= 10001) {
          newColors.push('#A91036')
        }

      }

      //set the graph data
      this.series = [{ name: "Confirmed", data: vals }];
      this.chartOptions = {
        colors: newColors,
        xaxis: {
          categories: cols
        }
      };
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
